import { ILocationState } from "@/Common/interfaces/location";
import { useSelector } from "react-redux";

export function useLocationId(): string {
	return useSelector((state: ILocationState) => state.location.location?.locationId);
}
